import { FaCar, FaFileSignature } from "react-icons/fa";
import { isoDateToString } from "../../util/format-date";
import { MdEditDocument, MdShield } from "react-icons/md";
import { useContext } from "react";
import { UtilityContext } from "../../context/util-context";
import { format, startOfDay } from "date-fns";

/** ========================================================================
 * * ApplicationCard Component
 * This component renders a card that displays application summary.
 * ========================================================================== */

export default function ApplicationCard({ application, onClick }) {
  const { navigate } = useContext(UtilityContext);
  const classNames = () => {
    let classes =
      "grid items-center text-sm gap-4 grid-cols-2 lg:grid-cols-9 pill";
    if (!application.onboarded) return classes + " border-stone-600";
    if (!application.dueDate) return classes + " border-red-600";
    const dueDate = startOfDay(new Date(application.dueDate));
    if ((application.dueDate && dueDate <= new Date()) || !application.lastPayment) return classes + " border-orange-500";
    return classes + " border-green-500";
  };

  const clickHandler = (e) => {
    if (onClick) onClick(application.id);
    else navigate(`/applications/info?id=${application.id}`, e);
  };

  return (
    <div onClick={(e) => clickHandler(e)} className={classNames()}>
      <p className="font-semibold lg:col-span-2 text-stone-200">
        {application.year} {application.make} {application.model}{" "}
        {application.vin.substring(13, 17)}
      </p>
      {application.partner && (
        <p className="lg:col-span-2 text-stone-200">
          {application.partner.name}
        </p>
      )}
      {application.dueDate ? (
        <p className="hidden lg:block ">
          {isoDateToString(application.dueDate, "do MMM yyyy")}
        </p>
      ) : (
        <p className="hidden lg:block animate-pulse warning">Not Provided</p>
      )}

      <p className="hidden text-stone-400 lg:block">
        {isoDateToString(application.lastPayment, "do MMM yyyy") || "-"}
      </p>

      {application.registerationExp ? (
        <p className={`hidden lg:block ${new Date(application.registerationExp) < new Date() &&  "text-red-600 animate-pulse"}`}>
          {isoDateToString(application.registerationExp, "do MMM yyyy")}
        </p>
      ) : (
        <p className="hidden lg:block animate-pulse warning">Not Provided</p>
      )}

      {application.monthlyPayment ? (
        <p className="font-semibold">
          ${application.monthlyPayment.toFixed(2)}
        </p>
      ) : (
        <p className="hidden animate-pulse warning lg:block">Not Provided</p>
      )}
      <div className="hidden lg:block">
        <ApplicationFlags application={application} />
      </div>
    </div>
  );
}

/** ========================================================================
 * * ApplicationFlags Component
 * This component renders a component that displays application's status summary.
 * ========================================================================== */

const ApplicationFlags = ({ application }) => {
  return (
    <div className="flex justify-around space-x-4">
      {application?.insurance ||
      new Date(application?.insuranceExp) > new Date() ? (
        <MdShield
          className="w-5 h-5 text-green-600"
          title="Vehicle insurance available"
        />
      ) : (
        <MdShield
          className="w-5 h-5 text-red-600"
          title="Vehicle insurance not available or expired"
        />
      )}
      {application.registeration ||
      new Date(application.registerationExp) > new Date() ? (
        <MdEditDocument
          className="w-5 h-5 text-green-600"
          title="Vehicle registeration available"
        />
      ) : (
        <MdEditDocument
          className="w-5 h-5 text-red-600"
          title="Vehicle registeration not available or expired"
        />
      )}
      {application?.agreement ? (
        <FaFileSignature
          className="w-5 h-5 text-green-600"
          title="Agreement Signed"
        />
      ) : (
        <FaFileSignature
          className="w-5 h-5 text-red-600"
          title="Agreement Not Signed"
        />
      )}
    </div>
  );
};
